import { Pipe, PipeTransform } from '@angular/core';
import { WeekDay } from '../api/contracts/menu';
import * as moment from 'moment';
import { WEEK_DAYS } from 'src/constants/date.constants';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'deliveryTime',
})
export class DeliveryTimePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}
  transform(day: WeekDay, workTime?: string): string {
    if (!workTime) {
      return '...';
    }
    const indexOfSelectedDay = WEEK_DAYS.indexOf(day);
    const diffFromToday = indexOfSelectedDay - moment().weekday();
    if (diffFromToday === 0) {
      return `${this.translateService.instant(
        `@common.days.diff.today`
      )}, ${workTime}`;
    }
    if (diffFromToday === 1) {
      return `${this.translateService.instant(
        `@common.days.diff.tomorrow`
      )}, ${workTime}`;
    }
    return `${this.translateService.instant(
      `@common.days.full.${day}`
    )}, ${workTime}`;
  }
}
